import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return <>{children}</>;
}
